import { render, staticRenderFns } from "./OuvidoriaReport.vue?vue&type=template&id=30087505&scoped=true&"
import script from "./OuvidoriaReport.vue?vue&type=script&lang=js&"
export * from "./OuvidoriaReport.vue?vue&type=script&lang=js&"
import style0 from "./OuvidoriaReport.vue?vue&type=style&index=0&id=30087505&scoped=true&lang=css&"
import style1 from "./OuvidoriaReport.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30087505",
  null
  
)

export default component.exports